module.exports = __webpack_public_path__ + "img/menu.28605327.svg";